import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const DiversityContext = React.createContext();

export const useDiversityContext = () => useContext(DiversityContext);

export function DiversityProvider({ children }) {
  const [banner, setBanner] = useState({});
  const [subcategories, setSubcategories] = useState([]);
  const [articles, setArticles] = useState([]);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchData.get('https://run.mocky.io/v3/986861b1-9bf2-4b8b-aa31-7562d8a4ac9b').then(setBanner);
    fetchData
      .get('https://run.mocky.io/v3/cce6bd7f-6758-456e-8b28-75e80d269157')
      .then(setSubcategories);
    fetchData.get('https://run.mocky.io/v3/aa16c95b-16ce-4f85-95d7-26b239a588c8').then(setArticles);
    fetchData.get('https://run.mocky.io/v3/ad83597b-e8d6-4652-a547-396feb51dfc9').then(setVideos);
  }, []);

  const value = useMemo(
    () => ({
      banner,
      subcategories,
      articles,
      videos,
    }),
    [banner, subcategories, articles, videos]
  );

  return <DiversityContext.Provider value={value}>{children}</DiversityContext.Provider>;
}
